import styled from 'styled-components'

import { fonts, palette } from '../../../styles/variables'

export const PlansContainer = styled.div(({ length }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fit, minmax(${
    length === 4 ? '100px' : '150px'
  }, 1fr))`,
  gap: length === 4 ? '10px' : '20px',
  width: '100%',
  gridAutoFlow: 'row',
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
  },
}))

export const PlanItem = styled.label(({ limitedOffer }) => ({
  cursor: 'pointer',
  height: 'auto',
  position: 'relative',
  background: palette.white,
  zIndex: limitedOffer ? 1 : 0,
  '& *': {
    cursor: 'pointer',
  },
  '@media (max-width: 600px)': {
    transform: 'none',
  },
}))

export const PlanRadioButton = styled.input(() => ({
  height: '100%',
  position: 'absolute',
  left: '-9999px',
  zIndex: -1,
  opacity: 0,
  '&:checked + div': {
    color: palette.white,
    boxShadow: '2px 8px 8px rgba(241, 100, 52, 0.10)',
    borderColor: palette.orange,
    background: palette.white,
    '&.discount': {
      background: palette.orange,
      '& > div': {
        color: palette.white,
      },
    },
    '& .plan-name': {
      color: palette.orange,
    },
    '& .plan-benefit': {
      background: palette.orange,
      color: palette.white,
    },
  },
}))

export const PlanContentWrapper = styled.div(({ limitedOffer }) => ({
  height: '100%',
  border: `1px solid ${palette.gray50}`,
  borderTop: `1px solid ${palette.gray50}`,
  borderRadius: '2px',
  borderTopLeftRadius: limitedOffer ? 0 : '2px',
  borderTopRightRadius: limitedOffer ? 0 : '2px',
  color: 'black',
  padding: '16px 10px 10px 10px',
  textAlign: 'center',
  width: '100%',
  position: 'relative',
  transition: 'border-color.3s ease',
  '@media (max-width: 600px)': {
    height: 'auto',
  },
}))

export const BenefitIndicator = styled.span(({ isLoading }) => ({
  marginLeft: '4px',
  fontFamily: fonts.primaryMedium,
  background: palette.lightGray50,
  color: palette.darkGray70,
  fontSize: '11px',
  padding: '6px',
  borderRadius: '2px',
  transition: 'all .3s ease',
  filter: isLoading ? 'blur(2px)' : 'none',
  whiteSpace: 'nowrap',
}))

export const PriceContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
})

export const PriceDisplay = styled.div({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const PriceValueContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: '16px',
  flexWrap: 'wrap',
  justifyContent: 'center',
})

export const PlanDescriptionWrapper = styled.div({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
})

export const PlanDescriptionText = styled.p(({ isLoading }) => ({
  width: '100%',
  fontSize: '12px',
  lineHeight: '130%',
  color: palette.raisinBlack70,
  filter: isLoading ? 'blur(2px)' : 'none',
  '& b': {
    color: palette.raisinBlack70,
    fontFamily: fonts.primaryBook,
    fontWeight: 700,
  },
}))

export const PlanBadgeWrapper = styled.div(({ background }) => ({
  padding: '5px 15px',
  background: background || palette.blue,
  borderBottom: 'none',
  borderTopRightRadius: '2px',
  borderTopLeftRadius: '2px',
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  clipPath: 'polygon(0% 0%, 100% 0%, 96% 50%, 100% 100%, 0% 100%, 4% 50%)',
  zIndex: 1,
  '& > div': {
    whiteSpace: 'nowrap',
  },
}))
